export default __webpack_public_path__ + "static/media/consortium.74229362.png";